import React from 'react';
import './CommonButton.scss';

interface ButtonProps {
  btnText: any;              // Text to display on the button
  key?: any;                // Key for options
  onClick: () => void;          // Function to execute when the button is clicked
  type?: 'button' | 'submit' | 'reset'; // Button type (default is 'button')
  className?: string;           // Custom CSS class for styling
  disabled?: boolean;           // Disable button (default is false)
  loading?: boolean;            // Loading state (default is false)
  color?: string;
  height? : string;
  backgroundColor?: string;     // Background color of the button (default is transparent)
  border?: string;              // Border property (e.g., "2px solid #333")
  borderRadius?: string;        // Border radius of the button (default is '4px')
}

const CommonButton: React.FC<ButtonProps> = ({
  btnText,
  onClick,
  type = 'button',
  className = '',
  disabled = false,
  loading = false,
  color = '#000000',
  height = '40px',
  backgroundColor = 'transparent',  // Default to transparent if not provided
  border = 'none',                  // Default to no border if not provided
  borderRadius = '4px',             // Default border radius of 4px
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`common-button ${className} ${loading ? 'loading' : ''}`}
      disabled={disabled || loading}
      style={{
        backgroundColor,
        border,
        borderRadius,
        color,
        height
      }}
    >
      {/* {loading ? (
        <div className="loading-spinner"></div>
      ) : (
        btnText
      )} */}
      {loading && (
        <div className="loading-spinner"></div>
      )}
      <span style={{ opacity: loading ? 0.7 : 1 }}>{btnText}</span>
    </button>
  );
};

export default CommonButton;
